module.exports = __webpack_public_path__ + "static/media/editUserEdit1.53342384.svg";